export default __webpack_public_path__ + "static/multi-cluster-kubernetes-management-with-meshery-21f7b4f3cce3b8315ba9474f874cdd52.webp";